'use client';

import { useSystemLabels } from '@eliadmin/core/src/hooks/use-system-labels';
import { Button } from '@eliadmin/core/src/components/ui/button';
import { ROUTES } from '@eliadmin/core/src/constants/routes';
import { useCartQueryOpts } from '@eliadmin/core/src/hooks/cart/use-cart';
import { useGlobalStore } from '@eliadmin/core/src/stores/global-store';
import { formatPrice } from '@eliadmin/core/src/utils/price-utils';
import { useQuery } from '@tanstack/react-query';
import Link from '@eliadmin/core/src/components/link';
import { MdShoppingCart } from 'react-icons/md';

export function HeaderCartButton() {
  const systemLabels = useSystemLabels();
  const currency = useGlobalStore((state) => state.generalLayout.currency);
  const currencySettings = useGlobalStore((state) => state.generalLayout.currency_settings);

  const { data: cart } = useQuery({ ...useCartQueryOpts() });

  const totalPriceNoVat = cart?.items_total_without_vat ?? 0;
  const displayedPrice = formatPrice(totalPriceNoVat, currency, currencySettings);

  return (
    <Button asChild variant={'outline'} className="whitespace-nowrap">
      <Link aria-label={`${systemLabels('cart')}: ${displayedPrice}`} href={ROUTES.CART()}>
        <div className="relative">
          {(cart?.items?.length ?? 0) > 0 && (
            <div className="absolute -right-[7px] -top-[7px] z-10 flex h-[18px] w-[18px] items-center justify-center whitespace-nowrap rounded-full bg-[#EA2A30] text-center text-xs text-white">
              {cart?.items?.length}
            </div>
          )}
          <MdShoppingCart size={24} className="text-foreground" />
        </div>
        {displayedPrice}
      </Link>
    </Button>
  );
}
